export default "__VITE_ASSET__BdUTzMX9__"